/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'react-redux';
import { updatePageDetails, changePage } from 'state/actions/app_status';
import { updateStepDetails } from 'state/actions/embedsState/embedManagementState/embed_management_status';
import { sendMessage} from 'utils/messages';
import { invalidateSelectedContent } from 'state/actions/embedsState/embedManagementState/content_status';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import ArrowStep from 'material/embeds/steps/stepindicator/arrowstep/arrowstep';



/* ========== ~~~~~~~~~~ STEPINDICATOR : ARROW STEP : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ embedsState }) => {
    const contentStatus = embedsState.embedManagementState.contentStatus;
    const currentStepIndex = embedsState.embedManagementState.embedManagementStatus.currentStepIndex;
    const stepQueue = embedsState.embedManagementState.embedManagementStatus.stepQueue;
    return {
        currentStepPage: embedsState.embedManagementState.embedManagementStatus.currentStepPage,
        currentStepIndex,
        currStepName: !currentStepIndex ? null : currentStepIndex >= 0 ? stepQueue[currentStepIndex]["name"] : null,
        selectedContent: !!contentStatus.contents ? contentStatus.contents[contentStatus.selectedContent] : null,
        isNewEmbedFlow: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.isNewEmbedFlow,
        isSavingData: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.isSavingData,
        changeDetected: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.embedChangeDetected ||
            embedsState.embedManagementState.contentStatus.contentChangeDetected
    }
};

// map actions
const mapDispatchToProps = dispatch => ({
	moveToPage: (location) => {
		dispatch(updatePageDetails(`dashboard/embeds/management/${location}`));
        dispatch(updateStepDetails(location));
    	dispatch(changePage(`dashboard/embeds/management/${location}`))
    },
    invalidateSelectedContent: () => dispatch(invalidateSelectedContent()),
    sendMessage: message => dispatch(sendMessage(message))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
export default connect(
	mapStateToProps,
    mapDispatchToProps
)(ArrowStep);